import { useScsApi } from 'infrastructure/api';

const EMPLOYEE_SCORE_REPORT_URL = '/employee/score/report';

const useEmployeeScoreService = () => {
  const { sendPostRequest } = useScsApi();

  const getEmployeeScoreReport = async ({
    metricsWeights,
    metricsBounds,
    period,
  }: {
    metricsWeights: Record<string, number>;
    metricsBounds: Record<string, { min: number; max: number }>;
    period: string;
  }) => {
    const requestBody = {
      metricsWeights,
      metricsBounds,
      period,
    };

    try {
      return await sendPostRequest(EMPLOYEE_SCORE_REPORT_URL, requestBody);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching employee score report:', error);
      throw error;
    }
  };

  return {
    getEmployeeScoreReport,
  };
};

export default useEmployeeScoreService;
